import React from 'react'
import { useLoaderData, useParams } from 'react-router-dom'
import PortfolioDetails from './PortfolioDetails';


const SinglePortfolio = () => {

const {singleportfolio} = useParams();
const portfolioAllData = useLoaderData();

let singleData=[];
const findPortfolio = portfolioAllData.find((portfolioId)=>portfolioId.id === +singleportfolio);
singleData.push(findPortfolio)

  return (
    <div className='bg-[#0E1629] py-20'>
        <div className='container mx-auto'>
            <div>
                {singleData.map((portfolioDetails)=><PortfolioDetails key={portfolioDetails.id} portfolioDetails={portfolioDetails}></PortfolioDetails>)}
            </div>
        </div>
    </div>
  )
}

export default SinglePortfolio